"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerOverlay = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../../../Css");
// Small wrapper around DatePicker to provide necessary styling and state handling when displayed as an overlay.
function DatePickerOverlay({ overlayProps, children }) {
    return ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.br4.bshModal.$, ...overlayProps, children: children }));
}
exports.DatePickerOverlay = DatePickerOverlay;
